import React from 'react';
import InfoTooltip from '../InfoTooltip';

const TimeBox = ({ finalTP, prevalence, sensitivity, specificity, }) => {
    const actualTrials = [
        { Screened: 6757, Included: 1643, Duration: 2.8 },
        { Screened: 6173, Included: 1653, Duration: 2.9 },
        { Screened: 3736, Included: 813, Duration: 1.8 },
        { Screened: 3664, Included: 806, Duration: 1.5 }
    ];

    // Calculating rates and efficiencies from actual trials
    const actualRates = actualTrials.map(trial => trial.Included / trial.Duration);
    const actualEfficiencies = actualTrials.map(trial => trial.Included / trial.Screened);
    const benchmarkEfficiency = actualEfficiencies.reduce((a, b) => a + b, 0) / actualEfficiencies.length;
    const meanRate = actualRates.reduce((a, b) => a + b, 0) / actualRates.length;

    const sampleSizeStep1 = Math.ceil(finalTP / (sensitivity * prevalence));

    const screenedOnlyScreening = finalTP / prevalence;
    const screenedPreScreening = sampleSizeStep1;
    const included = finalTP; // Assuming the same number of participants are included in both methods

    const efficiencyOnlyScreening = included / screenedOnlyScreening;
    const efficiencyPreScreening = included / screenedPreScreening;

    const efficiencyFactorOnlyScreening = efficiencyOnlyScreening / benchmarkEfficiency;
    const efficiencyFactorPreScreening = efficiencyPreScreening / benchmarkEfficiency;

    const timeToIncludeOnlyScreening = included / meanRate;
    const timeToIncludePreScreening = included / meanRate;

    const adjustedTimeToIncludeOnlyScreening = timeToIncludeOnlyScreening / efficiencyFactorOnlyScreening;
    const adjustedTimeToIncludePreScreening = timeToIncludePreScreening / efficiencyFactorPreScreening;

    const percentage = ((adjustedTimeToIncludePreScreening / adjustedTimeToIncludeOnlyScreening) - 1) * 100;

    const infoStyle = percentage > 0 ? { color: 'green' } : { color: 'red' };
    const iconName = percentage > 0 ? 'arrow-up' : 'arrow-down';

    return (
        <div className="p-3 card gradient1">
            <h4 className='d-flex'>Recruitment Time <InfoTooltip tooltipTextKey="tooltip_time_box" color="white" /></h4>
            <div className="card-body">
                <div className="info" style={infoStyle}>
                    <h5>{adjustedTimeToIncludePreScreening.toFixed(2)} years</h5>
                    <h6>{percentage.toFixed(2)}% <i className={`fas fa-${iconName}`}></i></h6>
                </div>
            </div>
        </div>
    );
};

export default TimeBox;